<template>
  <div class="goods-category-box" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <!-- 表格 -->
        <div class="btn" @click="categoryModal('add', { isFirst: true })">
          + 添加一级分类
        </div>
        <el-table
          :data="categoryList"
          class="goods-category-table table no-border-table"
          :tree-props="{ children: 'second', hasChildren: 'hasChildren' }"
          row-key="tid"
          ref="orderTable"
          :header-cell-style="{
            border: 'none',
            color: '#333',
            background: '#f6f6f6',
            borderBottom: '1px solid #E8E8E8',
            height: '54px',
          }"
          :row-style="{
            height: '54px',
          }"
        >
          <!-- <el-table-column
            type="index"
            :index="tableIndex"
            align="center"
            label="编号"
            width="120"
          ></el-table-column> -->
          <el-table-column
            prop="index"
            align="center"
            label="序号"
            width="120"
          ></el-table-column>
          <el-table-column
            prop="name"
            align="center"
            label="一级分类名称"
            width="360"
          >
            <div
              slot-scope="scope"
              :class="{ 'table-children': scope.row.isChildren }"
            >
              {{ scope.row.name }}
            </div>
          </el-table-column>
          <el-table-column prop="pic" align="center" label="分类配图">
            <div slot-scope="scope">
              <img class="img" :src="scope.row.pic" alt="" />
            </div>
          </el-table-column>
          <el-table-column
            prop="twig"
            align="center"
            label="排序"
          ></el-table-column>
          <el-table-column prop="recommend" align="center" label="设为推荐分类">
            <!-- <div
              slot-scope="scope"
              v-if="scope.row.isFirst"
              @click="handleRecommend(scope.row.id, scope.row.recommend)"
            >
              <i
                v-if="scope.row.recommend === 1"
                class="iconfont icon-checkbox checked-icon"
              ></i>
              <i v-else class="iconfont no-checked-icon"></i>
            </div> -->
            <div slot-scope="scope" v-if="scope.row.isFirst">
              {{ scope.row.recommend === 2 ? '是' : '否' }}
            </div>
          </el-table-column>
          <el-table-column prop="open" align="center" label="是否在C端展示">
            <!-- <div
              slot-scope="scope"
              v-if="scope.row.isFirst"
              @click="handleOpen(scope.row.id, scope.row.open)"
            >
              <i
                v-if="scope.row.open === 0"
                class="iconfont icon-checkbox checked-icon"
              ></i>
              <i v-else class="iconfont no-checked-icon"></i>
            </div> -->
            <div slot-scope="scope" v-if="scope.row.isFirst">
              {{ scope.row.open === 0 ? '是' : '否' }}
            </div>
          </el-table-column>
          <el-table-column prop="activateMember" align="center" label="是否开通会员">
            <!-- <div
              slot-scope="scope"
              v-if="!scope.row.isFirst"
              @click="handleOpen1(scope.row.id, scope.row.shopUse)"
            >
              <i
                v-if="scope.row.shopUse === 1"
                class="iconfont icon-checkbox checked-icon"
              ></i>
              <i v-else class="iconfont no-checked-icon"></i>
            </div> -->
            <div slot-scope="scope" v-if="scope.row.isFirst">
              {{ scope.row.activateMember === 1 ? '是' : '否' }}
            </div>
          </el-table-column>
          <el-table-column
            prop="twig"
            align="center"
            label="关联身份"
          >
          <div slot-scope="scope">
              <div v-if="scope.row.role">{{roleMap[scope.row.role]}}</div>
              <div v-else>无</div>
            </div>
          </el-table-column>
          <el-table-column label="操作" align="center" width="300">
            <div slot-scope="scope">
              <div>
                <button
                  size="mini"
                  class="table-btn"
                  @click="deleteCategory(scope.row.id, scope.row.isFirst)"
                >
                  删除
                </button>
                <button
                  size="mini"
                  class="table-btn"
                  @click="categoryModal('edit', scope.row)"
                >
                  编辑
                </button>
                <button
                  size="mini"
                  v-if="scope.row.isFirst"
                  class="table-btn"
                  @click="categoryModal('addChildren', scope.row)"
                >
                  添加子分类
                </button>
              </div>
            </div>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页按钮 -->
      <!-- <div class="footer">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          background
          layout="total, prev, pager, next, jumper"
          :page-size="size"
          :total="total"
        ></el-pagination>
      </div> -->
    </div>
    <!-- 发布公告弹窗 -->
    <el-dialog width="750px" :visible.sync="categoryShow">
      <div slot="title">
        <p class="dialog-title">
          {{ type === "add" ? "新增" : "编辑"
          }}{{ firstInfo.id ? "二级" : "一级" }}分类
        </p>
      </div>
      <div class="dialog-content">
        <el-form
          ref="form"
          :rules="rules"
          :model="form"
          class="category-form"
          label-width="auto"
        >
          <el-form-item
            v-if="firstInfo.id"
            label="所属一级分类："
            prop="name"
            class="form-item"
          >
            {{ firstInfo.name }}
          </el-form-item>
          <el-form-item
            :label="firstInfo.id ? '二级分类名称:' : '一级分类名称：'"
            prop="name"
            class="form-item"
          >
            <el-input
              placeholder="请输入分类名称"
              class="input"
              v-model="form.name"
            ></el-input>
          </el-form-item>
          <el-form-item label="排序：" prop="twig" class="form-item">
            <el-input
              placeholder="请输入序号"
              class="input"
              v-model.number="form.twig"
              type="number"
              onkeypress="return( /[\d]/.test(String.fromCharCode(event.keyCode)))"
            ></el-input>
            <div class="tip" style="margin-left: 12px">
              数值越大，排序越靠前
            </div>
          </el-form-item>
          <el-form-item class="img_item" prop="pic" label="图片：">
            <div class="addImg">
              <div class="img-box">
                <img ref="img" :src="form.pic" v-if="form.pic" />
                <div class="icon" v-else>
                  <p><i class="el-icon-plus" style="font-size: 32px"></i></p>
                  <!-- <p>图片</p> -->
                  <!-- <p class="tip">支持扩展名：.jpg .png</p> -->
                </div>
                <input
                  type="file"
                  class="file"
                  ref="inputImg"
                  @change="addChangeImg"
                />
              </div>
              <p class="tips">仅支持png格式</p>
            </div>
          </el-form-item>
          <el-form-item
            v-if="!firstInfo.id"
            label="设为推荐："
            prop="recommend"
            class="form-item"
          >
            <el-radio-group v-model="form.recommend">
              <el-radio :label="2">是</el-radio>
              <el-radio :label="1">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            v-if="!firstInfo.id"
            label="是否在C端显示："
            prop="open"
            class="form-item"
          >
            <el-radio-group v-model="form.open">
              <el-radio :label="0">是</el-radio>
              <el-radio :label="1">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            v-if="!firstInfo.id"
            label="是否开通会员："
            prop="activateMember"
            class="form-item"
          >
            <el-radio-group v-model="form.activateMember">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            v-if="!firstInfo.id"
            label="关联身份："
            prop="groupUid"
            class="form-item"
          >
            <el-select v-model="form.role" class="input" placeholder="请选择">
              <el-option
                v-for="item in role2"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <button
          class="btn cancel-btn"
          size="small"
          @click="categoryShow = false"
        >
          取 消
        </button>
        <button class="btn confirm-btn" size="small" @click="handleConfirm">
          确 定
        </button>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import dayjs from 'dayjs';
import Header from '../../components/common/header';
import { role } from '@/config.js';
export default {
  components: {
    Header
  },
  name: 'goods-category',
  data() {
    return {
      currentPage: 1, // 当前页码
      size: 9999, // 每页条数
      total: 0, // 总页数
      loading: 0, // 加载中
      title: {
        // 页面标题
        firstTitile: '商品管理',
        secondTitle: '商品分类管理'
      },
      type: '', // edit：修改  add：添加
      categoryInfo: {}, // 公告信息
      categoryList: [], // 公告列表
      categoryShow: false, // 公告弹窗
      firstInfo: {},
      form: {
        // 表单数据
        name: '',
        pic: '',
        twig: null,
        recommend: 2,
        open: 0,
        activateMember: 1,
        role: null
      },
      role: [],
      role2: [
        {
          id: 0,
          name: '无'
        },
        {
          id: 2,
          name: '店主'
        },
        {
          id: 3,
          name: '代理商'
        }
      ],
      roleMap: {},
      rules: {
        // 表单验证规则
        name: [{ required: true, message: '请输入内容', trigger: 'blur' }],
        twig: [{ required: true, message: '请输入内容', trigger: 'blur' }],
        pic: [{ required: true, message: '请输入内容', trigger: 'change' }]
      }
    };
  },
  mounted() {
    // 获取列表
    this.getCategoryList();
    this.getDictionary();
  },
  filters: {
    // 时间格式化
    dateFormat(date) {
      if (!date) return '请选择时间';
      let day = dayjs(date);
      return day.format('YYYY-MM-DD HH:mm:ss');
    }
  },
  computed: {},
  methods: {
    // 表格序号
    tableIndex(index) {
      return ++index;
    },
    // 切换页码
    handleCurrentChange(page) {
      this.currentPage = page;
      this.getCategoryList();
    },
    // 获取分区列表
    getCategoryList() {
      this.loading++;
      this.httpGet(this.$root.getGoodsCategoryList, {
        page: this.currentPage,
        size: this.size
      }).then(
        (res) => {
          this.loading--;
          this.categoryList = res.list.map((item, index) => {
            return {
              ...item,
              index: ++index,
              isFirst: true,
              tid: item.id,
              second: item.second.map((sec) => {
                return {
                  ...sec,
                  fName: item.name,
                  tid: item.id + '-' + sec.id
                };
              })
            };
          });
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    getDictionary(){
      this.getDictionaryByName('role');
    },
    getDictionaryByName(dataName){
      this.loading++;
      this.httpGet(this.$root.getDictionaryByName, {
        dataName
      }).then(
        (res) => {
          this.loading--;
          this[dataName] = res.list; 
          let obj = {};
          res.list.forEach(item => {
            obj[item.value] = item.labelName;
          });
          this[dataName + 'Map'] = obj;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    // 公告弹窗
    categoryModal(type, rowData = {}) {
      this.$refs.form && this.$refs.form.clearValidate();
      this.type = true;
      if ((rowData && type !== 'addChildren') || !rowData.isFirst) {
        this.form.name = rowData.name;
        this.form.pic = rowData.pic;
        this.form.twig = rowData.twig;
        this.form.id = rowData.id;
        this.form.recommend = rowData.recommend;
        this.form.open = rowData.open;
        this.form.activateMember = rowData.activateMember;
        this.form.role = rowData.role;
      } else {
        this.form = {
          name: '',
          pic: '',
          twig: null,
          recommend: 2,
          open: 0,
          activateMember: 1,
          role: null
        };
      }
      if (type === 'addChildren' || !rowData.isFirst) {
        this.firstInfo = rowData;
        this.form.fid = rowData.fid || rowData.id;
        this.type = false;
      } else {
        this.firstInfo = {};
      }
      // if (rowData.fName === '超值礼包') {
      //   this.form.genre = rowData.genre;
      //   this.form.genreValue = rowData.genreValue;
      //   // this.form.isRepurchase = rowData.isRepurchase || 0;
      //   this.form.role = rowData.role || null;
      // }
      this.categoryShow = true;
    },
    // 确认发布/修改公告
    handleConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading++;
          let inputData = {};
          let url = '';
          if (this.type) {
            url = this.$root.updateFirstCategory;
            inputData = this.form;
          } else {
            url = this.$root.updateSecondCategory;
            inputData = this.form;
          }
          this.categoryShow = false;
          inputData.unfreezeAmount = +inputData.unfreezeAmount || null;
          inputData.groupUid = +inputData.groupUid || null;
          this.httpPost(url, inputData).then(
            (res) => {
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.loading--;
              this.getCategoryList();
            },
            (res) => {
              this.loading--;
              this.$message.error(res);
            }
          );
        } else {
          return false;
        }
      });
    },
    // 删除分区
    deleteCategory(id, isFirst) {
      this.$confirm(
        `<p class='title'><i class='icon el-icon-question'></i>提醒</p><p class='text'>确定要删除该分类吗？</p>`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'cancel-btn',
          confirmButtonClass: 'confirm-btn',
          customClass: 'confirm-box',
          dangerouslyUseHTMLString: true,
          showClose: false,
          type: 'none'
        }
      ).then(() => {
        this.loading++;
        let url = isFirst
          ? this.$root.deleteFirstCategory
          : this.$root.deleteSecondCategory;
        this.httpDelete(url, {
          id
        }).then(
          (res) => {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.loading--;
            this.getCategoryList();
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
      });
    },
    handleRecommend(id, recommend) {
      this.$confirm(
        `<p class='title'><i class='icon el-icon-question'></i>提醒</p><p class='text'>是否设置该分类为推荐分类？</p>`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'cancel-btn',
          confirmButtonClass: 'confirm-btn',
          customClass: 'confirm-box',
          dangerouslyUseHTMLString: true,
          showClose: false,
          type: 'none'
        }
      ).then(() => {
        this.loading++;
        this.httpPost(this.$root.changeRecommend, {
          id,
          recommend: +!recommend
        }).then(
          (res) => {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.loading--;
            this.getCategoryList();
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
      });
    },
    handleOpen(id, open) {
      this.$confirm(
        `<p class='title'><i class='icon el-icon-question'></i>提醒</p><p class='text'>是否开启在C端展示？</p>`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'cancel-btn',
          confirmButtonClass: 'confirm-btn',
          customClass: 'confirm-box',
          dangerouslyUseHTMLString: true,
          showClose: false,
          type: 'none'
        }
      ).then(() => {
        this.loading++;
        this.httpPost(this.$root.changeCategoryOpen, {
          id,
          open: +!open
        }).then(
          (res) => {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.loading--;
            this.getCategoryList();
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
      });
    },
    handleOpen1(id, shopUse) {
      let str = '';
      if(shopUse === 1) str = '关闭';
      if(shopUse === 0) str = '开启';
      this.$confirm(
        `<p class='title'><i class='icon el-icon-question'></i>提醒</p><p class='text'>是否${str}商户专用分类？</p>`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'cancel-btn',
          confirmButtonClass: 'confirm-btn',
          customClass: 'confirm-box',
          dangerouslyUseHTMLString: true,
          showClose: false,
          type: 'none'
        }
      ).then(() => {
        this.loading++;
        this.httpPost(this.$root.changeCategoryOpen, {
          id,
          open: +!open
        }).then(
          (res) => {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.loading--;
            this.getCategoryList();
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
      });
    },
    // 图片改变
    addChangeImg(e) {
      this.upPic(e, (res) => {
        this.$set(this.form, 'pic', res);
        // 清空input value，解决重复图片不触发change
        this.$refs.inputImg.value = '';
        this.$refs.form.clearValidate(['pic']);
      });
    },
    // 上传图片
    upPic(e, fun) {
      // 上传图片
      let file = e.target.files[0];
      if (!file) {
        return;
      }
      this.request.upPic({ prefix: 'other', file: file }).then(
        (res) => {
          fun(res);
        },
        (res) => { }
      );
    }
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
@import '~assets/public.styl';
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.goods-category-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;

  .container {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    flex-y(flex-start, flex-start);
    padding: 24px;

    // content 表格
    .content {
      flex: 1;
      width: 100%;
      font-size: 14px;
      background: white;
      box-sizing: border-box;
      padding: 24px 32px;
      border-radius: 2px;

      .checked-icon {
        color: btn-color;
        font-size: 16px;
      }

      .no-checked-icon {
        display: inline-block;
        color: #aaa;
        border: 1px solid #aaa;
        background: #eee;
        width: 15px;
        height: 15px;
        border-radius: 3px;
        box-sizing: border-box;
      }

      // 按钮
      .btn {
        width: auto;
        height: 32px;
        line-height: 32px;
        confirm-btn();
        font-size: 14px;
        margin-bottom: 16px;
        display: inline-block;
        padding: 0 12px;
      }

      .table {
        .img {
          height: 48px;
          width: auto;
        }

        .table-children {
          transform: translateX(40%);
          white-space: nowrap;
        }
      }

      // 表格按钮
      .table-btn {
        width: 80px;
        height: 24px;
        line-height: 24px;
        color: gray3;
        font-size: 12px;
        margin-right: 8px;
        cancel-btn();
      }
    }
  }

  .footer {
    width: 100%;
    padding: 24px;
    box-sizing: border-box;
    flex-x(flex-end);
    background: white;
  }

  .dialog-content {
    flex-y();

    .addImg {
      flex-x(flex-start);

      .icon {
        width: 81px;
        height: 81px;
        background: #E8E8E8;
        border-width: 0;

        i {
          color: #999;
        }
      }

      .tips {
        align-self: flex-end;
        margin-left: 8px;
      }
    }

    .tip {
      margin-top: 0;
    }

    .tip {
      word(14px, gray9);
    }

    .input {
      width: 160px;
    }
  }

  .category-form {
    padding: 32px 0 10px;
  }
}
</style>
